export type TabKey = 'not-yet' | 'completed';

export const TAB_LIST: {
  key: TabKey;
  label: string;
  count: number;
}[] = [
  { key: 'not-yet', label: '미답변', count: 0 },
  { key: 'completed', label: '답변완료', count: 0 },
];

export const DEFAULT_TAB: TabKey = 'not-yet';
